import { render, staticRenderFns } from "./ExpressOrderCreation.vue?vue&type=template&id=6267faf2&scoped=true"
import script from "./ExpressOrderCreation.vue?vue&type=script&lang=js"
export * from "./ExpressOrderCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6267faf2",
  null
  
)

export default component.exports